import { Colors } from '../Colors';
export const TableOption = {
    sortIcon: {
        size: 20,
        color: Colors.grey,
    },
};
